import React, { useState } from 'react';
import { Search } from 'lucide-react';

/**
 * GlobalSearch Component
 * Komponen pencarian global yang mengarahkan ke halaman chat AI
 */
const GlobalSearch = ({ setPage }) => {
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearch = (e) => {
        if (e.key === 'Enter' && searchQuery.trim() !== '') {
            setPage('chat', { initialMessage: searchQuery });
        }
    };

    return (
        <div className="relative w-full max-w-xl">
            <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={handleSearch}
                placeholder="Cari atau Tanya AI..."
                className="w-full pl-10 lg:pl-12 pr-4 py-2 lg:py-3 text-sm lg:text-base border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            />
            <Search className="absolute left-3 lg:left-4 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 lg:w-5 lg:h-5" />
        </div>
    );
};

export default GlobalSearch;

